var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"co-scroll-up-button",class:{'is-visible': _vm.show}},[_c('fa',{staticClass:"co-scroll-up-button__icon",attrs:{"icon":['fas', 'arrow-circle-up']},on:{"click":function($event){return _vm.scrollToTop()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }